import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { PrivacyPageContentModel } from 'src/app/core/model/privacy-policy-content.model';
import { ContentfulService } from 'src/app/core/service/contentful.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit, AfterViewInit {  
  privacyPage!: PrivacyPageContentModel;

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
    private contentfulService: ContentfulService, 
    private sanitizer: DomSanitizer
  ) { }

  // Helper function to decode HTML entities
  private decodeHtmlEntities(text: string): string {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }
 
    loadPrivacyPolicyEntries() { 
    this.contentfulService.getEntry('privacyPolicyIdentifier', 'Privacy Policy').subscribe(
      (entry) => { 
        this.privacyPage = new PrivacyPageContentModel(entry);
        console.log('Privacy Policy PrivacyPageHeaderContentModel:', this.privacyPage);
        
        // Handle fragment navigation after data is loaded
        setTimeout(() => {
          this.route.fragment.subscribe(fragment => {
            if (fragment) {
              this.scrollToFragment(fragment);
            }
          });
        }, 100);
      }, error => {
        console.error('Error fetching privacy policy entries:', error);
      });
  } 

   getBreadcrumbs(): string[] {
    return this.privacyPage.heroBreadCrumbs.split(',').map(breadcrumb => breadcrumb.trim());
  }

  get sanitizedMasterSubHeader(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.masterSubHeader || '');
  }

  get sanitizedTypesOfPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderTypesOfPersonalInformation || '');
  }

  get sanitizedCollectionOfPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderCollectionofPersonalInformation || '');
  }

  get sanitizedProcessingOfPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderProcessingOfPersonalInformation || '');
  }

  get sanitizedDisclosureOfPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderDisclosureofPersonalInformation || '');
  }

  get sanitizedTrackingTechnologies(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderTrackingTechnologies || '');
  }

  get sanitizedSubTrackingTech(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subTrackingtechnology || '');
  }

  get sanitizedRightsAndChoices(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderYourRightsandChoices || '');
  }

  get sanitizedProtectPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderProtectPersonalInformation || '');
  }

  get sanitizedKeepPersonalInfo(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.privacyPage?.subHeaderKeepYourPersonalInformation || '');
  }

  get sanitizedImportantInfo(): SafeHtml {
    const content = this.privacyPage?.subHeaderImportantInformation || '';
    const decodedContent = this.decodeHtmlEntities(content);
    return this.sanitizer.bypassSecurityTrustHtml(decodedContent);
  }

  get sanitizedContactInfo(): SafeHtml {
    const content = this.privacyPage?.subHeaderContactInformation || '';
    const decodedContent = this.decodeHtmlEntities(content); 
    const sanitized = this.sanitizer.bypassSecurityTrustHtml(decodedContent); 
    return sanitized;
  }
 

  ngOnInit(): void { 
    console.log('Privacy Policy component initializing...');
    this.loadPrivacyPolicyEntries(); 
  }

  ngAfterViewInit(): void {
    // Fragment navigation is now handled after data loads in loadPrivacyPolicyEntries()
  }

  private scrollToFragment(fragment: string): void {
    try {
      console.log('Attempting to scroll to fragment:', fragment);
      const element = document.getElementById(fragment);
      console.log('Found element:', element);
      if (element) {
        // Add a small delay to ensure content is fully rendered
        setTimeout(() => {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
          console.log('Scrolled to element:', fragment);
        }, 200);
      } else {
        console.warn('Element not found for fragment:', fragment);
      }
    } catch (e) {
      console.error('Error scrolling to fragment:', e);
    }
  }

}